(ns nosco.icons
  (:require [shadow.resource :as rc]
            ["react" :as react]
            [clojure.string :as str]
            [hx.react :as hx :refer [defnc]]
            [nosco.ui.html]
            [nosco.react]
            [nosco.icons2]))


;; get the svg as a big string -- shadow.cljs makes sure to
;; refresh the build when the file changes to get hot reloading
(def raw-svg-source (rc/inline "icons.svg"))

;; load this element ONCE in the file, the huge svg is hidden
(defnc MainSVG []
  [:<>
   [nosco.ui.html/UnsafeHTML {:html raw-svg-source
                              :style {:display "none"}}]
   [nosco.icons2/MainSVG]])

; <svg class="nosco-icon"><use href="#icon-activity" xlink:href="#icon-activity"/></svg>
;; create an `svg` with a `use` element that refers an element from the huge svg above.
;; this is a nifty SVG feature that allows us to reference icons all over the place :)
(defn svg-icon
  ([icon] (svg-icon icon "nosco-icon"))
  ([icon class]
   (let [href (str "#" (str/trim (name icon)))]
     (react/createElement "svg"
                          #js {"className" class}
                          (react/createElement "use" #js {:href href
                                                          "xlinkHref" href})))))

(defnc Icon
  "Render an icon. Accepts both keywords and strings. Pass :icon-loading
  to render a spinning loader (different from icon-load which is not spinning)"
  [{:keys [icon] :as props}]
  (let [loading? (= (name icon) "icon-loading")
        icon (if loading? "icon-load" icon)
        href (str "#" (str/trim (name icon)))]
    [:svg
     (-> {:class ["nosco-icon" (when loading? "icon-spin")]
          :aria-label (name icon)}
         (nosco.react/merge-props (dissoc props :icon)))
     [:use {:href href :xlinkHref href}]]))

(defnc CircleIcon []
  [:svg {:style {:width "1em" :height "1em" :margin-bottom "1px"}}
   [:circle {:cx "50%" :cy "50%" :r "30%" :fill "currentColor"}]])

(defnc LoadingIcon [{:keys [style class]}]
  [Icon {:icon "icon-loading"
         :style style
         :class class}])
